import React from 'react'
import { Box, Typography } from '@mui/material'
import { Container, Row, Col, Image } from 'react-bootstrap'
import airportBlu from '../Assets/Images/airport-blu.png';
import hoursBlu from '../Assets/Images/24-hours-support-blu.png'
import flyBlu from '../Assets/Images/direct-flight-blu.png'
import certifiedBlu from '../Assets/Images/certified-blu.png'
import { motion } from 'framer-motion';

const BelowHomeslider = () => {
  return (
    <>
      <Box>
        <Container className='quickHighlights'>
            <Row>
                <Col lg='3' className='my-3 my-lg-5'>
                <motion.div 
                    initial={{ scale: 0.8, opacity: 0 }} 
                    whileInView={{ scale: 1, opacity: 1 }} 
                    transition={{ duration: 0.9, ease: "easeInOut"  }} 
                    viewport={{ once: false }} 
                    >
                    <Box className='highLight shine-hover'>
                        <Box className="ribbon">New</Box>
                        <Image className='img-fluid' src={airportBlu} />
                        <Typography variant="body1" component='p'>Partnered with major airports</Typography>
                    </Box>
                </motion.div>
                </Col>
                <Col lg='3' className='my-3 my-lg-5'>
                <motion.div 
                initial={{ scale: 0.8, opacity: 0 }} 
                    whileInView={{ scale: 1, opacity: 1 }} 
                    transition={{ duration: 0.9, ease: "easeInOut"  }} 
                    viewport={{ once: false }} 
                    >
                    <Box className='highLight shine-hover'>
                    <Box className="ribbon">24x7</Box>
                        <Image className='img-fluid' src={hoursBlu} />
                        <Typography variant="body1" component='p'>24/7 Customer Support</Typography>
                    </Box>
                </motion.div>
                </Col>
                <Col lg='3' className='my-3 my-lg-5'>
                <motion.div 
                    initial={{ scale: 0.8, opacity: 0 }} 
                    whileInView={{ scale: 1, opacity: 1 }} 
                    transition={{ duration: 0.9, ease: "easeInOut"  }} 
                    viewport={{ once: false }} 
                >
                        <Box className='highLight shine-hover'>
                        <Box className="ribbon">Featured</Box>
                        <Image className='img-fluid' src={flyBlu} />
                        <Typography variant="body1" component='p'>Fly Across All India</Typography>
                    </Box>
                    </motion.div>
                </Col>
                <Col lg='3' className='my-3 my-lg-5'>
                <motion.div 
                    initial={{ scale: 0.8, opacity: 0 }} 
                    whileInView={{ scale: 1, opacity: 1 }} 
                    transition={{ duration: 0.9, ease: "easeInOut"  }} 
                    viewport={{ once: false }} 
                >
                        <Box className='highLight shine-hover'>
                        <Box className="ribbon">Exclusive</Box>
                        <Image className='img-fluid' src={certifiedBlu} />
                        <Typography variant="body1" component='p'>Certified by DGCA & ISO</Typography>
                    </Box>
                </motion.div>
                </Col>
            </Row>
        </Container>
      </Box>
    </>
  )
}

export default BelowHomeslider
